import { render, staticRenderFns } from "./UploadMdmCert.vue?vue&type=template&id=190fd455&scoped=true&"
import script from "./UploadMdmCert.vue?vue&type=script&lang=js&"
export * from "./UploadMdmCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fd455",
  null
  
)

export default component.exports